<template>
   <div>
    
    <div class="seleccion">
        <h4 class="titulo">{{secciones.Titulo}}</h4>
        <select  @change="cambioDeSeccion($event)" class="col-12" >
        <option v-for="seccionQueMePertenece in secciones.SeccionesQueMePertenecenMicrositio" :key="seccionQueMePertenece.SeccionesDeMicrositioId" :value="seccionQueMePertenece.SeccionesDeMicrositioId"> {{seccionQueMePertenece.Titulo}}</option>
    </select>
    </div>
<div v-for="tabla in RegresaSeccionesQueMePertenecen.ContenidoDeMicrositio" :key="tabla.ContenidoDeMicrositioId">
    <h4>{{tabla.TextoDelVinculo}}</h4>
    <table class="table table-striped table-hover table-bordered mt-4">
                  <thead class="thead-dark">
                    <tr>
                      <th></th>
                      <th class="titulo text-center" v-for="(titulo,index) in tabla.TextoDelContenido.split('|')" :key="index" >{{titulo}}</th> 
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(data, index) in tabla.ArchivosDeContenidoMicrositios" :key="index">
                      <th class="text-center texto">{{index+1}}</th>

                      <th class="texto">{{data.TextoDescripcion}}</th>

                      <th class="w-10 text-center vinculo texto">
                        <a v-if="data.AbrirEnVisor==false" v-on:click="AbrirArchivo(data.ArchivoAdicional,'_self')">{{data.TextoLink}}</a>
                        <a v-if="data.AbrirEnVisor==true" v-on:click="AbreElVisor(data.ArchivoAdicional)">{{data.TextoLink}}</a>
                      </th>
                   </tr>  
                  </tbody>       
     </table>
</div>


</div>


</template>
<script>
import comun from "@/../static/js/comun";
export default {
    data(){
        return{
            seccionesFiltrada:{}
        }
    },
    props:{
        secciones:Object
    },
    methods: {
        cambioDeSeccion($event){
            this.seccionesFiltrada = this.buscarTablas($event.target.value);
        },
        buscarTablas(grupo){ 
          //  console.log("GRUPO:::",grupo)
           var SeccionSeleccionada = {};
          // console.log("SECCIONES::::",this.secciones.SeccionesQueMePertenecenMicrositio)
            this.secciones.SeccionesQueMePertenecenMicrositio.forEach(element => {
                if(element.SeccionesDeMicrositioId == grupo){
                    SeccionSeleccionada=element;
                }
                
            });
            //console.log("SeccionSeleccionada::::",SeccionSeleccionada)
            return SeccionSeleccionada

        },
        AbreElVisor: function(vinculo) {
       //console.log("vinculo multiples tablas:::",vinculo)
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      AbrirArchivo: function(vinculo,forma) {
          // console.log("vinculo abrir archivo tablas:::",vinculo)
          if (vinculo.includes(".xlsm"))
          window.open(vinculo,"_blank");
          else
            comun.DescargarDocumentoPDF(vinculo);
          //  window.open(vinculo,forma);
        },
        
    },
    computed:{
        RegresaSeccionesQueMePertenecen(){
            return this.seccionesFiltrada;
        }
    },
    mounted() {
        this.seccionesFiltrada = this.buscarTablas(this.secciones.SeccionesQueMePertenecenMicrositio[0].SeccionesDeMicrositioId)
    },
}
</script>

<style scoped>
.titulo{
    margin-bottom: 1em;
}
.seleccion {
  appearance: none;

  margin-top: 2em;
  margin-bottom: 2em;
  position: relative;
}

.seleccion select {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  padding: 7px 10px;
  height: 42px;
  outline: 0;
  border: 0;
  border-radius: 0;
  background: #f0f0f0;
  color: #7b7b7b;
  font-size: 1.5em;
  color: #999;
  font-family: "AntenaBeta";
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  position: relative;
  transition: all 0.25s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/SelectMultiplesTablas.vue